<template>
		<div class="content home-page">
		<Header></Header>
      <div class="" @click="back" style="text-align: left;;align-items: center;justify-content: center;">
        <img style="width: 1.5rem;margin-left: 1rem" src="../../static/images/back.png" />
      </div>
			<div class="info crfff">
        <div class="fs50 mt50 ac">{{$t('invitation')}}</div>
        <div class="ac mt50">
          <img style="width: 13rem" src="../../static/images/int-img.png" />
        </div>
        <div class="fs33 mt20 ac">{{$t('invitationTips')}}</div>
        <div class="input-item mt50">
          <div class="input-item2">
            <input class="input" v-model="invite_url" disabled type="" placeholder="">
          </div>
        </div>
        <div class="ac mt50">
          <button class="button fw7" style="width: 100%;font-size: 1rem" id="copycode" :data-clipboard-text="invite_url"
                  @click="copy(invite_url)">{{ $t('InviteNow') }}
            <img style="width: 1.2rem" src="../../static/images/copy1.png"/>
          </button>
        </div>
			</div>
<!--      <div class="footer mt100">-->
<!--        <div class="home-bottom ac mt50">-->
<!--          <div class="footer-content ac">-->
<!--            <a class="crfff" href="#/faq">{{$t('FAQ')}}</a>-->
<!--            <a class="crfff" href="#/termsAndCondition">{{$t('TC')}}</a>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="copyright">{{$t('Copyright')}}</div>-->
<!--      </div>-->
		</div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:true,
       score:'',
       invite_url:''
      }
    },
	created(){
    this.getUserInfo()
    // this.invite_url = localStorage.getItem('int_url')
	},
  methods: {
    getUserInfo(){
      let that =this;
      that.$api.get('/api/user/info',null,r =>{
        that.$parent.returnCode(r,function(){
          that.invite_url=r.data.invite_url
        });
      })
    },
		back(){
			this.$router.go(-1);
		},
    copy(item){
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/invitation.vue